import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-naac-report',
  templateUrl: './naac-report.component.html',
  styleUrls: ['./naac-report.component.scss']
})
export class NaacReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
